<template>
  <div class="instructions">
    <h3 class="h4">Background</h3>
    <p>This exercise is designed to gain clarity around your values and which ones you hold in the highest regard. Our
       values, if clearly identified, can serve as a metaphorical compass to guide our choices and subsequently our
       actions.</p>
    <h3 class="h4">Instructions</h3>
    <p>This is a four step exercise. You will be provided a selection of {{ allValues.length }} values in which through
       processes of elimination and pairwise ranking you will determine your Top Five Values.</p>
    <div class="steps">
      <h4 class="step-title h5">Step One:</h4>
      <p>You will select {{ remainder1 }} values from the initial list of {{ allValues.length }}. Don't overthink
         this first step. Just select the first {{ remainder1 }} that call to you. If you are having trouble finding
         {{ remainder1 }} values that you strongly identify with... don't worry, simply select enough to complete the
         step. In the next step, you will be able to further refine your selection.</p>
      <h4 class="step-title h5">Step Two:</h4>
      <p>You will select {{ remainder2 }} values from the {{ remainder1 }} selected in the previous step. Once again,
         don't overthink it. However, ensure you are first selecting those you feel the most strong about and then fill
         in the remaining requirement.</p>
      <h4 class="step-title h5">Step Three:</h4>
      <p>This is the final bulk elimination. You will select {{ remainder3 }} values from your selection of
         {{ remainder2 }} from the previous step. By this point, you should identify with each of the remaining values
         to a minimum a moderate extent.</p>
      <h4 class="step-title h5">Step Four:</h4>
      <p>You will rank the remaining {{ remainder3 }} values through a pairwise comparison ranking procedure.  Once the ranking is complete, you will be provided with your Top {{ resultCount }} Values.</p>
    </div>

    <div class="next-step">
      <button class="button filled accent-1 begin"
              @click.prevent="this.$parent.showInstructions = false; this.$parent.workStarted ++; scrollToTop()">
        {{ this.$parent.workStarted ? "Continue" : "Get Started" }}
      </button>
    </div>
    <p class="notice">
      <strong>Notice: </strong>
      <i>The results of this exercise are private. No data is captured nor stored throughout the process. You will be
         prompted to download a PDF of your responses when complete. This PDF is generated on demand and will not be
         saved for future review.</i>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    showInstructions: {
      type: Boolean
    },
    workStarted:      {
      type: Number
    },
    allValues:        {
      type: Array
    },
    remainder1:       {
      type: Number
    },
    remainder2:       {
      type: Number
    },
    remainder3:       {
      type: Number
    },
    resultCount:      {
      type: Number
    }
  },
  data() {
    return {};
  },
  mounted() {
  },
  computed: {},
  methods:  {
    scrollToTop() {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
  }
}
</script>
